<template>
  <v-layout row>
    <v-flex xs12 pa-5>
      <v-card
        tile
        class="mx-auto"
      >
      <v-flex>
        <v-progress-linear
          color="#009933"
          height="4.5"
          indeterminate
          :active="loading"
        />
        </v-flex>
      <v-list dense>
            <v-list-item-subtitle class="pl-4 pt-2">
              Add HIS Partner
            </v-list-item-subtitle>
        </v-list>
        <v-form class="px-8 ma-6">
          <v-list dense  class="ma-0 pa-0">
            <v-text-field
              class="ma-0 pa-0"
              v-model="name"
              label="HIS Partner Name"
              color="#006622"
              filled
              required
              prepend-icon="mdi-doctor"
            />
          </v-list>
              <v-list dense class="ma-0 pa-0">
              <v-autocomplete
                class="ma-0 pa-0"
                v-model="userGroupId"
                item-value="id"
                :items="groupItem"
                label="Stakeholder Group"
                color="#006622"
                filled
                :item-text=" item=>item.name"
                required
                prepend-icon="mdi-account-group"
              />
          </v-list>
          <v-list dense class="ma-0 pa-0">
            <v-card-actions id="btn-group" class="pb-6" width="100%">
              <v-btn @click="addUserType" class="px-12 text-none" color="#339966" dark style="font-size: 0.88em;"> Add HIS Partner </v-btn>
            </v-card-actions>
          </v-list>
        </v-form>
        <v-spacer/>
      </v-card>
    </v-flex>
    <v-snackbar
      id="snack"
      color="#339966"
      v-model="snackbar"
      right
      style="position: fixed; "
      class="mb-6 ma-19"
    >
      <v-layout class="pa-4">
        <span name="app" dark style=" font-size: 0.88em;"><v-icon color="white" > {{snackbarError.icon}}</v-icon> {{snackbarError.label}}  </span>
        <v-spacer/>
      </v-layout>
   </v-snackbar>
  </v-layout>
</template>

<script>
export default {
  name: 'App',
  props: {
    source: String
  },
  data: () => {
    return {
      snackbar: false,
      loading: false,
      systemMessage: null,
      name: null,
      userGroupId: null,
      groupItem: [],
      snackbarError: { icon: 'mdi-server-network-off', label: 'A system error occurred, please try again.' }
    }
  },
  mounted: [
    function () {
      const passphrase = process.env.VUE_APP_PASSPHRASE
      const accessToken = localStorage.getItem('token')
      const decryptedAccessToken = this.CryptoJS.AES.decrypt(accessToken, passphrase).toString(this.CryptoJS.enc.Utf8)
      window.axios.defaults.headers.common.Authorization = `Bearer ${decryptedAccessToken}`
      window.axios.get('/userGroup/findAll')
        .then((response) => {
          this.groupItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
        })
    }
  ],
  methods: {
    reset () {
      this.name = ''
      this.userGroupId = null
    },
    addUserType () {
      if (this.name === '' || this.name === null) {
        this.snackbar = true
        this.snackbarError = { icon: 'mdi-server-security', label: `Please enter the HIS partner's name.` }
      } else if (this.userGroupId === '' || this.userGroupId === null) {
        this.snackbar = true
        this.snackbarError = { icon: 'mdi-server-security', label: 'Please select the Stakeholder group.' }
      } else {
        this.loading = true
        this.systemMessage = ''
        window.axios.post('/userType/insert', { name: this.name, userGroupId: this.userGroupId })
          .then((response) => {
            // eslint-disable-next-line
            var affectedRows = response.data.affectedRows
            if (affectedRows === 1) {
              this.reset()
              this.snackbar = true
              this.snackbarError = { icon: 'mdi-server-security', label: 'Successfully added the HIS partner.' }
            } else {
              this.snackbar = true
              this.snackbarError = { icon: 'mdi-server-security', label: 'Failed to add the HIS partner.' }
            }
            this.loading = false
          })
          // eslint-disable-next-line handle-callback-err
          .catch(() => {
            this.snackbar = true
            this.snackbarError = { icon: 'mdi-server-security', label: 'A system error occurred please try again.' }
            this.loading = false
          })
      }
    }
  }
}
</script>

<style scoped>
#btn-group{
  justify-content: center;
}
.v-text-field >>> input {
    font-size: 0.84em;
}
.v-text-field >>> label {
    font-size: 0.84em;
}
</style>
